import React, { FC } from 'react'

type IconProps = {
  className?: string
  size?: number
}
export const LinkIcon: FC<IconProps> = ({ className, size }) => {
  return (
    <svg
      className={className}
      fill={'none'}
      height={size}
      viewBox={'0 0 24 24'}
      width={size}
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <path
        d={
          'M21.7688 12.4312L17.5312 16.6687C15.3938 18.7687 11.9813 18.7687 9.88125 16.6687C7.89375 14.6437 7.78125 11.4562 9.61875 9.31873L9.80625 9.09373C10.1438 8.71873 10.7063 8.68123 11.0813 9.01873C11.4563 9.35623 11.4938 9.91873 11.1562 10.2937L11.0063 10.4812C9.73125 11.9062 9.80625 14.0437 11.1562 15.3937C12.5438 16.7812 14.8313 16.7812 16.2563 15.3937L20.4938 11.1562C21.8813 9.73123 21.8813 7.48123 20.4938 6.05623C19.1438 4.74373 17.0063 4.66873 15.5813 5.90623L15.3563 6.09373C14.9813 6.43123 14.4188 6.39373 14.0813 6.01873C13.7438 5.64373 13.7813 5.08123 14.1563 4.74373L14.3813 4.55623C16.5188 2.68123 19.7438 2.79373 21.7688 4.78123C23.8688 6.88123 23.8688 10.2937 21.7688 12.4312ZM2.23125 11.5687L6.50625 7.33123C8.60625 5.23123 12.0188 5.23123 14.1188 7.33123C16.1438 9.31873 16.2563 12.5437 14.3813 14.6812L14.1563 14.9062C13.8563 15.2812 13.2563 15.3562 12.8813 15.0187C12.5063 14.6812 12.4688 14.1187 12.8063 13.7437L13.0313 13.5187C14.2688 12.0937 14.1938 9.95623 12.8438 8.60623C11.4563 7.18123 9.16875 7.18123 7.78125 8.60623L3.50625 12.8437C2.11875 14.2312 2.11875 16.5187 3.50625 17.9437C4.85625 19.2562 6.99375 19.3312 8.41875 18.0937L8.64375 17.9062C9.01875 17.5687 9.58125 17.6062 9.91875 17.9812C10.2563 18.3562 10.2188 18.9187 9.84375 19.2562L9.61875 19.4437C7.48125 21.3187 4.25625 21.2062 2.23125 19.2187C0.13125 17.1187 0.13125 13.6687 2.23125 11.5687Z'
        }
        fill={'#141414'}
      />
    </svg>
  )
}
